var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-loading-spinner position-relative" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
        staticClass: "loading-progress",
        class: _vm.loadingProgressClasses,
      },
      [
        _c("LoadingIndicatorCircular", {
          staticClass: "progress-indicator",
          attrs: { size: 50, type: "undetermined" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }